import * as actions from '../../redux/actions';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const Footer2 = ({ operator }) => {
	return (
		operator && (
			<div
				className="themes-footer-2 "
				style={{
					color: operator && operator.color_codes && operator.color_codes.secondary_text_color,
					marginTop: '15px'
				}}
			>
				<div
					className="d-flex-c p-4"
					style={{
						background:
							operator &&
							operator.color_codes &&
							operator.color_codes.footer_color &&
							operator.color_codes.footer_color,
					}}
				>
					<div className="d-flex-sb-ac ">
						<div className="footer-logo" style={{ width: 'auto', marginRight: 20 }}>
							<a href="/">
								<img
									// src={getIcons('footerLogo', operator)}
									src={operator && operator.footer_logo ? operator.footer_logo : ''}
									// alt={this.props.t('TRANSLATIONS.VIATUR_LOGO')}
									style={{
										marginTop: '0',
										width: operator && operator.footer_logo_width && operator.footer_logo_width,
										height: operator.operator_name === 'centraltour' ? 40 : operator.operator_name === 'jeldres' ? "auto" : 50,
									}}
									alt=""
								/>
							</a>
						</div>

						<div className="info f-13">
							{operator.phone_number ? (
								<div className="mb-1">
									<img
										src={getIcons('phone', operator)}
										alt="DIS"
										className="top_icon"

									// alt={this.props.t('TRANSLATIONS.MAIN_LOGO')}
									/>
									{operator && operator.phone_number}
								</div>
							) : null}

							{operator.operator_name === 'jeldres' && operator.email ? (
								<div className="mb-1">
									<img
										src={getIcons('email', operator)}
										alt="DIS"
										className="top_icon"

									// alt={this.props.t('TRANSLATIONS.MAIN_LOGO')}
									/>
									{operator && operator.email}
								</div>
							) : null}

							{operator.address ? (
								<div className="d-flex-c ">
									<img src={getIcons('location', operator)} alt="DIS" className="top_icon" />
									{operator.address}
								</div>
							) : null}

							{operator && operator.operator_name === 'trrass' ? (
								<div className="d-flex-c " style={{ marginTop: 20 }}>
									<a
										href=" https://www.facebook.com/profile.php?id=100076487192710"
										target="_blank"
									>
										<div className="trrass-fb"></div>
									</a>
									<a href="https://www.instagram.com/busestrrasschile/" target="_blank">
										<div className="trrass-insta"></div>
									</a>
								</div>
							) : null}
						</div>
						{/* )} */}
					</div>
				</div>

				{operator && operator.show_bottom_footer ? <ShowBottomFooter operator={operator} /> : null}
			</div>
		)
	);
};

const ShowBottomFooter = ({ operator }) => {
	return (
		<div
			className="d-flex-c f-13 p-2"
			style={{
				background: operator && operator.color_codes ? operator.color_codes.sub_footer_color : '',
				color: operator && operator.color_codes && operator.color_codes.secondary_text_color,
			}}
		>
			<div>
				<span className="poppins-medium">{operator.name} {new Date().getFullYear()} </span>
				<span className="poppins-light">© - Todos los derechos reservados | Powered by</span>
				<a href="https://kupos.cl" target="_blank">
					<img
						src={getIcons('BottomFooterKuposLogo', operator)}
						// alt={this.props.t('TRANSLATIONS.VIATUR_LOGO')}
						className="footer-kupos-logo"
						alt=""
					/>
				</a>
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer2);



// WEBPACK FOOTER //
// ./src/features/themes/common/footer/Footer2.js